<template>
  <div>
    <v-card class="overflow-hidden">
      <v-card-text>
        <v-row>
          <v-col>
            <customer-autocomplete-filter
              :fatherEditedCustomer="filterDiscount"
              :editedCustomerIndex="-1"
              :customerName="'quotation_shortname'"
              @setFilterCustomer="setFilterCustomer"
            />
          </v-col>
          <v-col>
            <v-text-field
              :label="$t('quotation_license_plate')"
              v-model="filterDiscount.LicensePlate"
              @input="getDiscountList"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-data-table
      :headers="discountDataTableHeaders"
      :items="discountList"
      class="elevation-1 mt-5"
      :no-data-text="$t('common_no_data')"
      :no-results-text="$t('common_no_results')"
      :loading="isLoadingDiscount"
      :loading-text="$t('common_get_data')"
      :footer-props="{
        'items-per-page-options': [30, 50, 100],
        'items-per-page-text': $t('item_rows_per_page'),
      }"
      :header-props="headerProps"
      :server-items-length="totalRows"
      :options="currentOptions"
      @update:options="updateOptions"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>{{ $t('discount_title') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-dialog v-model="isShowEditDiscountDialog" fullscreen persistent>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" dark class="mb-2 ml-8" v-bind="attrs" v-on="on">
                {{ $t('common_new') }}
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="text-h5">{{ discountDialogTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <ValidationObserver ref="dialogDiscount">
                    <v-row>
                      <v-col cols="12" sm="6" md="4" xl="3" lg="3">
                        <customer-autocomplete
                          :fatherEditedCustomer="editedDiscount"
                          :editedCustomerIndex="-1"
                          :customerName="'quotation_customer_number'"
                          @setCustomer="setCustomer"
                          v-if="editedDiscountIndex === -1"
                          refName="customerAutocomplete"
                          @keyupEnter="focusNextInput"
                        />
                        <ValidationProvider
                          :name="$t('quotation_customer_number')"
                          rules="required"
                          v-slot="{ errors }"
                          v-else
                        >
                          <v-text-field
                            v-model="editedDiscount.CustomerNumber"
                            :label="$t('quotation_customer_number')"
                            disabled
                            :error-messages="errors[0]"
                          >
                            <template v-slot:label>
                              <span class="red--text">
                                <strong>* </strong>
                              </span>
                              {{ $t('quotation_customer_number') }}
                            </template>
                          </v-text-field>
                        </ValidationProvider>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" xl="3" lg="3">
                        <ValidationProvider
                          :name="$t('quotation_shortname')"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            v-model="editedDiscount.CustomerName"
                            :label="$t('quotation_shortname')"
                            disabled
                            :error-messages="errors[0]"
                          >
                            <template v-slot:label>
                              <span class="red--text">
                                <strong>* </strong>
                              </span>
                              {{ $t('quotation_shortname') }}
                            </template>
                          </v-text-field>
                        </ValidationProvider>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" xl="3" lg="3">
                        <ValidationProvider
                          :name="$t('quotation_full_name')"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            v-model="editedDiscount.CustomerFullName"
                            :label="$t('quotation_full_name')"
                            disabled
                            :error-messages="errors[0]"
                          >
                            <template v-slot:label>
                              <span class="red--text">
                                <strong>* </strong>
                              </span>
                              {{ $t('quotation_full_name') }}
                            </template>
                          </v-text-field>
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="6" md="4" xl="3" lg="3">
                        <ValidationProvider
                          :name="$t('quotation_license_plate')"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            v-model.trim="editedDiscount.LicensePlate"
                            :label="$t('quotation_license_plate')"
                            :error-messages="errors[0]"
                            required
                            clearable
                            :disabled="isAllTextFieldDisable"
                            @keyup.enter="focusNextInput"
                            @change="getMonthList"
                          >
                            <template v-slot:label>
                              <span class="red--text">
                                <strong>* </strong>
                              </span>
                              {{ $t('quotation_license_plate') }}
                            </template>
                          </v-text-field>
                        </ValidationProvider>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" xl="3" lg="3">
                        <ValidationProvider
                          :name="$t('discount_month_total')"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            v-model="editedDiscount.MonthTotal"
                            :label="$t('discount_month_total')"
                            :error-messages="errors[0]"
                            required
                            clearable
                            :disabled="isAllTextFieldDisable"
                            @keyup.enter="focusNextInput"
                          >
                            <template v-slot:label>
                              <span class="red--text">
                                <strong>* </strong>
                              </span>
                              {{ $t('discount_month_total') }}
                            </template>
                          </v-text-field>
                        </ValidationProvider>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" xl="3" lg="3">
                        <ValidationProvider
                          :name="$t('quotation_item_rent_warranty_period')"
                          :rules="{ required: true, regex: /^[0-9]+$/ }"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            v-model="editedDiscount.WarrantyPeriod"
                            :label="$t('quotation_item_rent_warranty_period')"
                            :error-messages="errors[0]"
                            required
                            clearable
                            :disabled="isAllTextFieldDisable"
                            @keyup.enter="focusNextInput"
                          >
                            <template v-slot:label>
                              <span class="red--text">
                                <strong>* </strong>
                              </span>
                              {{ $t('quotation_item_rent_warranty_period') }}
                            </template>
                          </v-text-field>
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                  </ValidationObserver>
                </v-container>
              </v-card-text>

              <v-data-table
                :headers="discountItemDataTableHeaders"
                :items="editedDiscount.NewDiscountItems"
                :search="searchDiscountItem"
                class="elevation-1  mt-5 mx-10"
                :no-data-text="$t('common_no_data')"
                :no-results-text="$t('common_no_results')"
                :footer-props="{
                  'items-per-page-options': [30, 50, 100],
                  'items-per-page-text': $t('item_rows_per_page'),
                }"
                :header-props="headerProps"
              >
                <template v-slot:top>
                  <v-toolbar flat>
                    <v-toolbar-title></v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-text-field
                      v-model="searchDiscountItem"
                      append-icon="mdi-magnify"
                      :label="$t('customer_repair_item_search_label')"
                      single-line
                      hide-details
                      clearable
                    ></v-text-field>
                    <v-btn
                      color="primary"
                      dark
                      class="mb-2 ml-8"
                      @click="isShowEditDiscountItemDialog = true"
                      :disabled="isAllTextFieldDisable"
                    >
                      {{ $t('common_new') }}
                    </v-btn>
                    <v-dialog
                      v-model="isShowEditDiscountItemDialog"
                      v-if="isShowEditDiscountItemDialog"
                      fullscreen
                      persistent
                    >
                      <v-card>
                        <v-card-title>
                          <span class="text-h5">{{ discountItemDialogTitle }}</span>
                        </v-card-title>
                        <v-card-text>
                          <v-container>
                            <ValidationObserver ref="discountItem">
                              <v-row>
                                <v-col cols="12" sm="6" md="4" xl="3" lg="3"
                                  ><v-checkbox
                                    v-model="editedDiscountItem.IsRepeat"
                                    :label="$t('discount_item_repeat')"
                                    :disabled="isLookMode"
                                  ></v-checkbox>
                                </v-col>
                                <v-col cols="12" sm="6" md="4" xl="3" lg="3">
                                  <ValidationProvider
                                    :name="$t('discount_item_repeat_warranty_period')"
                                    rules="required"
                                    v-slot="{ errors }"
                                    v-if="editedDiscountItem.IsRepeat"
                                  >
                                    <v-text-field
                                      v-model="editedDiscountItem.RepeatWarrantyPeriod"
                                      v-if="editedDiscountItem.IsRepeat"
                                      @keyup.enter="focusNextInput"
                                      :error-messages="errors[0]"
                                      :disabled="isLookMode"
                                    >
                                      <template v-slot:label>
                                        <span class="red--text">
                                          <strong>* </strong>
                                        </span>
                                        {{ $t('discount_item_repeat_warranty_period') }}
                                      </template>
                                    </v-text-field>
                                  </ValidationProvider>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col
                                  cols="12"
                                  sm="6"
                                  md="4"
                                  lg="3"
                                  xl="3"
                                  v-if="editedDiscountItemIndex !== -1"
                                >
                                  <v-text-field
                                    v-model="editedDiscountItem.DiscountId"
                                    label="折扣專屬ID"
                                    disabled
                                  >
                                  </v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                  <v-autocomplete
                                    v-model="editedDiscountItem.WaitForDiscountIds"
                                    :items="waitForDiscountOptions"
                                    item-text="DiscountId"
                                    item-value="DiscountId"
                                    label="等待優惠結束"
                                    :disabled="isLookMode"
                                    :loading-text="$t('common_get_data')"
                                    :no-data-text="$t('common_no_data')"
                                    clearable
                                    multiple
                                    chips
                                    small-chips
                                    deletable-chips
                                    @change="onWaitForDiscountIdsChange"
                                  >
                                    <template v-slot:item="{ item }">
                                      <v-list-item-content>
                                        <v-list-item-title>{{ item.DiscountId }}</v-list-item-title>
                                        <v-list-item-subtitle
                                          >{{ item.MonthItemNumber }} -
                                          {{ item.MonthItemName }}
                                        </v-list-item-subtitle>
                                      </v-list-item-content>
                                    </template>
                                  </v-autocomplete>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                  <item-for-discount-month-autocomplete
                                    :editedItemIndex="editedDiscountItemIndex"
                                    :itemName="'quotation_item_number'"
                                    :monthItemList="monthItemList"
                                    @setEditedItem="setEditedDiscountItem"
                                    v-if="
                                      editedDiscountItemIndex === -1 &&
                                        !editedDiscountItem.MonthItemNumber
                                    "
                                    refName="itemAutocomplete"
                                    @keyupEnter="focusNextInput"
                                  />
                                  <v-text-field
                                    v-model="editedDiscountItem.MonthItemNumber"
                                    disabled
                                    :label="$t('quotation_item_number')"
                                    v-else
                                  >
                                  </v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                  <ValidationProvider
                                    :name="$t('quotation_item_name')"
                                    rules="required"
                                    v-slot="{ errors }"
                                    v-if="editedDiscountItem.MonthItemNumber"
                                  >
                                    <v-text-field
                                      v-model="editedDiscountItem.MonthItemName"
                                      disabled
                                      :error-messages="errors[0]"
                                    >
                                      <template v-slot:label>
                                        <span class="red--text">
                                          <strong>* </strong>
                                        </span>
                                        {{ $t('quotation_item_name') }}
                                      </template>
                                    </v-text-field>
                                  </ValidationProvider>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" sm="6" md="4" xl="3" lg="3">
                                  <ValidationProvider
                                    :name="$t('discount_item_type')"
                                    rules="required"
                                    v-slot="{ errors }"
                                  >
                                    <v-autocomplete
                                      v-model="editedDiscountItem.DiscountType"
                                      :items="allDiscountType"
                                      item-text="Name"
                                      item-value="Type"
                                      :disabled="isAllTextFieldDisable || isLookMode"
                                      :loading-text="$t('common_get_data')"
                                      :no-data-text="$t('common_no_data')"
                                      @keyup.enter="setDiscountTypeAutocomplete"
                                      ref="discountTypeAutocomplete"
                                      :error-messages="errors[0]"
                                      @change="setAllDiscount"
                                    >
                                      <template v-slot:label>
                                        <span class="red--text">
                                          <strong>* </strong>
                                        </span>
                                        {{ $t('discount_item_type') }}
                                      </template>
                                    </v-autocomplete>
                                  </ValidationProvider>
                                </v-col>
                                <v-col cols="12" sm="6" md="4" xl="3" lg="3">
                                  <ValidationProvider
                                    :name="$t('discount_item_use_type')"
                                    rules="required"
                                    v-slot="{ errors }"
                                  >
                                    <v-autocomplete
                                      v-model="editedDiscountItem.UseDiscountType"
                                      :items="allDiscountItemType"
                                      item-text="Name"
                                      item-value="Type"
                                      :disabled="
                                        isAllTextFieldDisable || lockUseDiscountType || isLookMode
                                      "
                                      :loading-text="$t('common_get_data')"
                                      :no-data-text="$t('common_no_data')"
                                      @keyup.enter="setUseDiscountTypeAutocomplete"
                                      ref="useDiscountTypeAutocomplete"
                                      :error-messages="errors[0]"
                                      @change="setUseDiscountType"
                                    >
                                      <template v-slot:label>
                                        <span class="red--text">
                                          <strong>* </strong>
                                        </span>
                                        {{ $t('discount_item_use_type') }}
                                      </template>
                                    </v-autocomplete>
                                  </ValidationProvider>
                                </v-col>

                                <v-col cols="12" sm="6" md="4" xl="3" lg="3">
                                  <ValidationProvider
                                    :name="$t('discount_item_use_month')"
                                    rules="required"
                                    v-slot="{ errors }"
                                    v-if="editedDiscountItem.UseDiscountType === 2"
                                  >
                                    <v-autocomplete
                                      v-model="editedDiscountItem.Months"
                                      :items="allMonth"
                                      :label="$t('discount_item_use_month')"
                                      chips
                                      multiple
                                      small-chips
                                      :disabled="isAllTextFieldDisable || isLookMode"
                                      :loading-text="$t('common_get_data')"
                                      :no-data-text="$t('common_no_data')"
                                      v-if="editedDiscountItem.UseDiscountType === 2"
                                      @change="setGiveWarrantyPeriod"
                                      :error-messages="errors[0]"
                                    ></v-autocomplete>
                                  </ValidationProvider>
                                  <ValidationProvider
                                    :name="$t('discount_item_use_warranty_period')"
                                    rules="required"
                                    v-slot="{ errors }"
                                    v-if="editedDiscountItem.UseDiscountType === 1"
                                  >
                                    <v-autocomplete
                                      v-model="editedDiscountItem.UseWarrantyPeriods"
                                      :items="allWarrantyPeriod"
                                      multiple
                                      small-chips
                                      :disabled="isAllTextFieldDisable || isLookMode"
                                      :loading-text="$t('common_get_data')"
                                      :no-data-text="$t('common_no_data')"
                                      v-if="editedDiscountItem.UseDiscountType === 1"
                                      @keydown.enter="setKeyDownAutocomplete"
                                      @keyup.enter="setKeyUpAutocomplete"
                                      ref="useWarrantyPeriodsAutocomplete"
                                      :error-messages="errors[0]"
                                      @change="setGiveWarrantyPeriod"
                                    >
                                      <template v-slot:label>
                                        <span class="red--text">
                                          <strong>* </strong>
                                        </span>
                                        {{ $t('discount_item_use_warranty_period') }}
                                      </template>
                                    </v-autocomplete>
                                  </ValidationProvider>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" sm="6" md="4" xl="3" lg="3">
                                  <date-picker-required
                                    :dateName="'discount_item_title_time'"
                                    :isAllTextFieldDisabled="false"
                                    @setDate="setStartTime"
                                    @keyupEnter="focusNextInput"
                                    v-if="
                                      editedDiscountItemIndex === -1 &&
                                        (!editedDiscountItem.WaitForDiscountIds ||
                                          editedDiscountItem.WaitForDiscountIds.length === 0)
                                    "
                                  />
                                  <ValidationProvider
                                    :name="$t('discount_item_title_time')"
                                    rules="required"
                                    v-slot="{ errors }"
                                    v-else
                                  >
                                    <v-text-field
                                      v-model="computeStartTime"
                                      required
                                      disabled
                                      :error-messages="errors[0]"
                                    >
                                      <template v-slot:label>
                                        <span class="red--text">
                                          <strong>* </strong>
                                        </span>
                                        {{ $t('discount_item_title_time') }}
                                      </template>
                                    </v-text-field>
                                  </ValidationProvider>
                                </v-col>
                                <v-col cols="12" sm="6" md="4" xl="3" lg="3">
                                  <ValidationProvider
                                    :name="$t('discount_item_give_warranty_period')"
                                    rules="required"
                                    v-slot="{ errors }"
                                    v-if="editedDiscountItem.DiscountType === 1"
                                  >
                                    <v-text-field
                                      v-model="editedDiscountItem.GiveWarrantyPeriod"
                                      v-if="editedDiscountItem.DiscountType === 1"
                                      @keyup.enter="focusNextInput"
                                      :error-messages="errors[0]"
                                      :disabled="isLookMode || isLockGiveWarrantyPeriod"
                                      @change="setGiveDay"
                                    >
                                      <template v-slot:label>
                                        <span class="red--text">
                                          <strong>* </strong>
                                        </span>
                                        {{ $t('discount_item_give_warranty_period') }}
                                      </template>
                                    </v-text-field>
                                  </ValidationProvider>
                                  <ValidationProvider
                                    :name="$t('discount_item_give_money')"
                                    rules="required"
                                    v-slot="{ errors }"
                                    v-if="editedDiscountItem.DiscountType === 2"
                                  >
                                    <v-text-field
                                      v-model="editedDiscountItem.GiveMoney"
                                      v-if="editedDiscountItem.DiscountType === 2"
                                      @keyup.enter="focusNextInput"
                                      :error-messages="errors[0]"
                                      :disabled="isLookMode"
                                    >
                                      <template v-slot:label>
                                        <span class="red--text">
                                          <strong>* </strong>
                                        </span>
                                        {{ $t('discount_item_give_money') }}
                                      </template>
                                    </v-text-field>
                                  </ValidationProvider>
                                  <ValidationProvider
                                    :name="$t('discount_item_give_percent')"
                                    rules="required"
                                    v-slot="{ errors }"
                                    v-if="editedDiscountItem.DiscountType === 3"
                                  >
                                    <v-text-field
                                      v-model="editedDiscountItem.GivePercent"
                                      v-if="editedDiscountItem.DiscountType === 3"
                                      @keyup.enter="focusNextInput"
                                      :error-messages="errors[0]"
                                      :disabled="isLookMode"
                                    >
                                      <template v-slot:label>
                                        <span class="red--text">
                                          <strong>* </strong>
                                        </span>
                                        {{ $t('discount_item_give_percent') }}
                                      </template>
                                    </v-text-field>
                                  </ValidationProvider>
                                  <ValidationProvider
                                    name="折扣天數"
                                    rules="required"
                                    v-slot="{ errors }"
                                    v-if="
                                      editedDiscountItem.DiscountType === 1 ||
                                        editedDiscountItem.DiscountType === 5
                                    "
                                  >
                                    <v-text-field
                                      v-model="editedDiscountItem.GiveDay"
                                      @keyup.enter="focusNextInput"
                                      :error-messages="errors[0]"
                                      :disabled="
                                        isLookMode || editedDiscountItem.DiscountType === 1
                                      "
                                    >
                                      <template v-slot:label>
                                        <span class="red--text">
                                          <strong>* </strong>
                                        </span>
                                        折扣天數
                                      </template>
                                    </v-text-field>
                                  </ValidationProvider>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-textarea
                                  outlined
                                  :label="$t('quotation_item_remark')"
                                  v-model="editedDiscountItem.Remark"
                                  :disabled="isLookMode"
                                ></v-textarea>
                              </v-row>
                            </ValidationObserver>
                          </v-container>
                        </v-card-text>
                        <v-data-table
                          :headers="groupTitle"
                          hide-default-header
                          hide-default-footer
                          :items="editedDiscountItem.GroupDiscountList"
                          single-expand
                          item-key="Sort"
                          show-expand
                          class="elevation-1 mx-5"
                          :no-data-text="$t('common_no_data')"
                          :no-results-text="$t('common_no_results')"
                          v-if="isLookMode"
                        >
                          <template v-slot:[`item.Sort`]="{ item }">
                            {{ combineText(item) }}
                          </template>
                          <template v-slot:expanded-item="{ headers, item }">
                            <td :colspan="headers.length" style="background-color: white;">
                              <v-tabs>
                                <v-tab href="#tab-1">折扣條件明細</v-tab>
                                <v-tab href="#tab-2">折扣活動紀錄</v-tab>
                                <v-tab-item value="tab-1">
                                  <v-data-table
                                    :headers="groupDiscountItemDataTableHeaders"
                                    :items="item.GroupDiscountItemList"
                                    class="ma-2"
                                    :loading-text="$t('common_get_data')"
                                    :no-data-text="$t('common_no_data')"
                                    :no-results-text="$t('common_no_results')"
                                    :footer-props="{
                                      'items-per-page-options': [30, 50, 100],
                                      'items-per-page-text': $t('item_rows_per_page'),
                                    }"
                                    :header-props="headerProps"
                                  >
                                    <template v-slot:top>
                                      <v-dialog
                                        v-model="isShowEditGroupDiscountItemDialog"
                                        max-width="800"
                                        persistent
                                      >
                                        <v-card>
                                          <v-card-title>
                                            <span class="text-h5"></span>
                                          </v-card-title>
                                          <v-card-text>
                                            <v-container>
                                              <v-data-table
                                                :headers="discountRecordDataTableHeaders"
                                                :items="editedGroupDiscountItem.DiscountRecordList"
                                                :search="searchDiscountRecord"
                                                class="elevation-1"
                                                :no-data-text="$t('common_no_data')"
                                                :no-results-text="$t('common_no_results')"
                                                :footer-props="{
                                                  'items-per-page-options': [30, 50, 100],
                                                  'items-per-page-text': $t('item_rows_per_page'),
                                                }"
                                              >
                                                <template v-slot:top>
                                                  <v-toolbar flat>
                                                    <v-spacer></v-spacer>
                                                    <v-text-field
                                                      v-model="searchDiscountRecord"
                                                      append-icon="mdi-magnify"
                                                      :label="
                                                        $t('quotation_item_new_install_search')
                                                      "
                                                      single-line
                                                      hide-details
                                                      clearable
                                                    ></v-text-field>
                                                  </v-toolbar>
                                                </template>
                                                <template v-slot:[`item.DiscountTime`]="{ item }">
                                                  {{ convertToDateTimeFormat(item.DiscountTime) }}
                                                </template>
                                              </v-data-table>
                                            </v-container>
                                          </v-card-text>
                                          <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn
                                              color="red darken-1"
                                              text
                                              @click="closeEditGroupDiscountItem"
                                            >
                                              {{ $t('common_cancel') }}
                                            </v-btn>
                                          </v-card-actions>
                                        </v-card>
                                      </v-dialog>
                                    </template>
                                    <template v-slot:[`item.Edit`]="{ index, item }">
                                      <v-btn
                                        icon
                                        @click="isShowEditGroupDiscountItemDialogBtn(index, item)"
                                        :disabled="isAllTextFieldDisable"
                                      >
                                        <v-icon small>
                                          mdi-eye
                                        </v-icon>
                                      </v-btn>
                                    </template>
                                  </v-data-table>
                                </v-tab-item>
                                <v-tab-item value="tab-2">
                                  <v-data-table
                                    :headers="computedDiscountRecordDataTableHeaders"
                                    :items="item.ComputedDiscountRecordList"
                                    class="ma-2"
                                    :loading-text="$t('common_get_data')"
                                    :no-data-text="$t('common_no_data')"
                                    :no-results-text="$t('common_no_results')"
                                    :footer-props="{
                                      'items-per-page-options': [30, 50, 100],
                                      'items-per-page-text': $t('item_rows_per_page'),
                                    }"
                                    :header-props="headerProps"
                                  >
                                    <template v-slot:[`item.StartTime`]="{ item }">
                                      {{ convertToDateTimeFormat(item.StartTime) }}
                                    </template>
                                    <template v-slot:[`item.EndTime`]="{ item }">
                                      {{ convertToDateTimeFormat(item.EndTime) }}
                                    </template>
                                  </v-data-table>
                                </v-tab-item>
                              </v-tabs>
                            </td>
                          </template>
                        </v-data-table>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="red darken-1" text @click="closeEditDiscountItem">
                            {{ $t('common_cancel') }}
                          </v-btn>
                          <v-btn
                            color="green darken-1"
                            v-if="!isLookMode"
                            text
                            @click="addDiscountItem"
                          >
                            {{ $t('common_confirm') }}
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                    <delete-dialog
                      :isAllTextFieldDisable="isAllTextFieldDisable"
                      :isLoadingSaveBtn="isLoadingSaveBtn"
                      :isShowDeleteDialog="isShowDeleteDiscountItemDialog"
                      :deleteMessage="'bom_item_delete_dialog_message'"
                      @closeDelete="closeDeleteDiscountItem"
                      @confirmDelete="confirmDeleteDiscountItem"
                    />
                  </v-toolbar>
                </template>
                <template v-slot:[`item.IsEnd`]="{ item }">
                  <v-icon v-if="item.IsEnd" color="success">mdi-check</v-icon>
                  <v-icon v-else color="error">mdi-close</v-icon>
                </template>
                <template v-slot:[`item.UseDiscountType`]="{ item }">
                  {{ turnUseDiscountType(item.UseDiscountType) }}
                </template>
                <template v-slot:[`item.DiscountType`]="{ item }">
                  {{ turnDiscountType(item.DiscountType) }}
                </template>
                <template v-slot:[`item.StartTime`]="{ item }">
                  {{ convertToDateTimeFormat(item.StartTime) }}
                </template>
                <template v-slot:[`item.GiveWarrantyPeriod`]="{ item }">
                  {{ item.GiveWarrantyPeriod }}
                </template>
                <template v-slot:[`item.WaitForDiscountIds`]="{ item }">
                  <v-chip v-for="id in item.WaitForDiscountIds" :key="id" small class="ma-1">
                    {{ id }}
                  </v-chip>
                </template>
                <template v-slot:[`item.Edit`]="{ item }">
                  <v-btn
                    icon
                    @click="isShowEditDiscountItemDialogBtn(item)"
                    :disabled="isAllTextFieldDisable"
                    v-if="item.GroupDiscountList.length === 0"
                  >
                    <v-icon small>
                      mdi-pencil
                    </v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    @click="isShowDeleteDiscountItemDialogBtn(item)"
                    :disabled="isAllTextFieldDisable"
                    v-if="item.GroupDiscountList.length === 0"
                  >
                    <v-icon small>
                      mdi-delete
                    </v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    @click="isShowEditDiscountItemDialogBtn(item)"
                    :disabled="isAllTextFieldDisable"
                    v-if="item.GroupDiscountList.length !== 0"
                  >
                    <v-icon small>
                      mdi-eye
                    </v-icon>
                  </v-btn>
                </template>
              </v-data-table>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="red darken-1"
                  text
                  @click="closeEditDiscountDialog"
                  :disabled="isAllTextFieldDisable"
                >
                  {{ $t('common_cancel') }}
                </v-btn>
                <v-btn
                  color="green darken-1"
                  text
                  @click="saveDiscount"
                  :loading="isLoadingSaveBtn"
                >
                  {{ $t('common_save') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <delete-dialog
            :isAllTextFieldDisable="isAllTextFieldDisable"
            :isLoadingSaveBtn="isLoadingSaveBtn"
            :isShowDeleteDialog="isShowDeleteDiscountDialog"
            :deleteMessage="'bom_delete_dialog_message'"
            @closeDelete="closeDeleteDiscount"
            @confirmDelete="confirmDeleteDiscount"
          />
        </v-toolbar>
      </template>
      <template v-slot:[`item.Edit`]="{ item }">
        <v-btn icon @click="isShowEditDiscountDialogBtn(item)">
          <v-icon small>
            mdi-pencil
          </v-icon>
        </v-btn>
        <v-btn icon @click="isShowDeleteDialogBtn(item)">
          <v-icon small>
            mdi-delete
          </v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import CustomerAutocomplete from '@/components/CustomerAutocomplete.vue'
import DeleteDialog from '@/components/DeleteDialog.vue'
import { HttpDiscount, HttpMonth } from '@/js/http-Manager'
import { DiscountType } from '@/js/DiscountType'
import { UseDiscountType } from '@/js/UseDiscountType'
import DatePickerRequired from '@/components/DatePickerRequired.vue'
import ItemForDiscountMonthAutocomplete from '@/components/ItemForDiscountMonthAutocomplete.vue'
import CustomerAutocompleteFilter from '@/components/CustomerAutocompleteFilter.vue'

export default {
  components: {
    CustomerAutocomplete,
    DeleteDialog,
    DatePickerRequired,
    ItemForDiscountMonthAutocomplete,
    CustomerAutocompleteFilter
  },
  name: 'NewDiscount',

  data: () => ({
    discountList: [],
    isLoadingDiscount: false,
    isShowEditDiscountDialog: false,
    editedDiscount: {
      CustomerId: '',
      CustomerNumber: '',
      CustomerName: '',
      CustomerFullName: '',
      LicensePlate: '',
      MonthTotal: '',
      WarrantyPeriod: '',
      DiscountItems: [],
      NewDiscountItems: []
    },
    defaultDiscount: {
      CustomerId: '',
      CustomerNumber: '',
      CustomerName: '',
      CustomerFullName: '',
      LicensePlate: '',
      MonthTotal: 0,
      WarrantyPeriod: 0,
      DiscountItems: [],
      NewDiscountItems: []
    },
    editedDiscountIndex: -1,
    isAllTextFieldDisable: false,
    isLoadingSaveBtn: false,
    isShowDeleteDiscountDialog: false,
    isShowEditDiscountItemDialog: false,
    isShowDeleteDiscountItemDialog: false,
    editedDiscountItemIndex: -1,
    searchDiscountItem: '',
    editedDiscountItem: {
      DiscountId: '',
      WaitForDiscountIds: [],
      IsEnd: false,
      MonthId: '',
      MonthNumber: '',
      MonthWarrantyPeriod: 0,
      MonthItemId: '',
      MonthItemName: '',
      MonthItemNumber: '',
      DiscountType: 0,
      StartTime: 0,
      IsRepeat: false,
      RepeatWarrantyPeriod: 0,
      RepeatDay: 0,
      GiveWarrantyPeriod: 0,
      GiveDay: 0,
      GiveMoney: 0,
      GivePercent: 0,
      UseDiscountType: 0,
      UseWarrantyPeriods: [],
      UseOnDays: [],
      Remark: '',
      Month: 0,
      Months: [],
      GroupDiscountList: []
    },
    defaultDiscountItem: {
      DiscountId: '',
      WaitForDiscountIds: [],
      IsEnd: false,
      MonthId: '',
      MonthNumber: '',
      MonthWarrantyPeriod: 0,
      MonthItemId: '',
      MonthItemName: '',
      MonthItemNumber: '',
      DiscountType: 0,
      StartTime: 0,
      IsRepeat: false,
      RepeatWarrantyPeriod: 0,
      RepeatDay: 0,
      GiveWarrantyPeriod: 0,
      GiveDay: 0,
      GiveMoney: 0,
      GivePercent: 0,
      UseDiscountType: 0,
      UseWarrantyPeriods: [],
      UseOnDays: [],
      Remark: '',
      Month: 0,
      Months: [],
      GroupDiscountList: []
    },
    allDiscountType: [],
    allDiscountItemType: [],
    lockUseDiscountType: false,
    tempUseWarrantyPeriods: [],
    isShowEditGroupDiscountItemDialog: false,
    searchDiscountRecord: '',
    editedGroupDiscountItemIndex: -1,
    editedGroupDiscountItem: {
      IsAchieve: false,
      UseWarrantyPeriod: 0,
      UseOnDay: 0,
      UseMonth: 0,
      DiscountPay: 0,
      IsDiscountDone: false,
      DiscountRecordList: []
    },
    defaultGroupDiscountItem: {
      IsAchieve: false,
      UseWarrantyPeriod: 0,
      UseOnDay: 0,
      UseMonth: 0,
      DiscountPay: 0,
      IsDiscountDone: false,
      DiscountRecordList: []
    },
    monthItemList: [],
    isLockGiveWarrantyPeriod: false,
    currentOptions: {
      page: 1,
      itemsPerPage: 30,
      sortBy: [],
      sortDesc: [],
      groupBy: [],
      groupDesc: [],
      multiSort: false,
      mustSort: false,
      triggerByOutsite: true
    },
    isUpdateEventTotal: true,
    totalRows: 0,
    filterDiscount: {
      CustomerId: '',
      LicensePlate: ''
    }
  }),
  computed: {
    discountDataTableHeaders () {
      return [
        { text: this.$t('quotation_customer_number'), value: 'CustomerNumber', sortable: false },
        { text: this.$t('quotation_shortname'), value: 'CustomerName', sortable: false },
        { text: this.$t('quotation_full_name'), value: 'CustomerFullName', sortable: false },
        { text: this.$t('quotation_license_plate'), value: 'LicensePlate' },
        { text: this.$t('discount_month_total'), value: 'MonthTotal', sortable: false },
        {
          text: this.$t('quotation_item_rent_warranty_period'),
          value: 'WarrantyPeriod',
          sortable: false
        },
        { text: this.$t('common_edit'), value: 'Edit', sortable: false }
      ]
    },
    headerProps () {
      return { sortByText: this.$t('installation_acceptance_header_sort') }
    },
    discountDialogTitle () {
      return this.editedDiscountIndex === -1 ? this.$t('common_new') : this.$t('common_edit')
    },
    discountItemDataTableHeaders () {
      return [
        { text: '已結案', value: 'IsEnd', sortable: false },
        { text: 'ID', value: 'DiscountId' },
        { text: this.$t('quotation_item_number'), value: 'MonthItemNumber' },
        { text: this.$t('quotation_item_name'), value: 'MonthItemName' },
        { text: this.$t('quotation_item_month_number'), value: 'MonthNumber' },
        { text: this.$t('discount_item_repeat'), value: 'IsRepeat' },
        { text: this.$t('discount_item_repeat_warranty_period'), value: 'RepeatWarrantyPeriod' },
        { text: this.$t('discount_item_type'), value: 'DiscountType' },
        { text: this.$t('discount_item_give_warranty_period'), value: 'GiveWarrantyPeriod' },
        { text: '贈送天數', value: 'GiveDay' },
        { text: this.$t('discount_item_give_money'), value: 'GiveMoney' },
        { text: this.$t('discount_item_give_percent'), value: 'GivePercent' },
        { text: this.$t('discount_item_title_time'), value: 'StartTime' },
        { text: this.$t('discount_item_use_type'), value: 'UseDiscountType' },
        { text: this.$t('discount_item_use_warranty_period'), value: 'UseWarrantyPeriods' },
        { text: this.$t('discount_item_use_month'), value: 'Months' },
        { text: this.$t('quotation_item_remark'), value: 'Remark' },
        { text: '等待優惠結束', value: 'WaitForDiscountIds' },
        { text: this.$t('common_look'), value: 'Edit', sortable: false }
      ]
    },
    isLookMode () {
      return this.editedDiscountItem.GroupDiscountList.length !== 0
    },
    discountItemDialogTitle () {
      if (this.editedDiscountItemIndex === -1) {
        return this.$t('common_new')
      } else if (this.editedDiscountItem.GroupDiscountList.length !== 0) {
        return this.$t('common_look')
      } else {
        return this.$t('common_edit')
      }
    },
    computeStartTime () {
      return this.convertToDateTimeFormat(this.editedDiscountItem.StartTime)
    },
    allMonth () {
      let array = []
      for (let index = 1; index < 13; index++) {
        array.push(index)
      }
      return array
    },
    waitForDiscountOptions () {
      // 先過濾掉 IsRepeat 為 true 的項目，並排除自己
      let filtered = (this.editedDiscount.NewDiscountItems || []).filter(
        (x) => !x.IsRepeat && x.DiscountId !== this.editedDiscountItem.DiscountId
      )

      // 如果已選擇項目，只顯示相同 MonthItemNumber 的項目
      let selectedIds = this.editedDiscountItem.WaitForDiscountIds || []
      if (selectedIds.length > 0) {
        // 找到第一個已選項目的 MonthItemNumber
        let selectedItem = filtered.find((x) => x.DiscountId === selectedIds[0])
        if (selectedItem) {
          return filtered.filter((x) => x.MonthItemNumber === selectedItem.MonthItemNumber)
        }
      }
      return filtered
    },
    allWarrantyPeriod () {
      let array = []
      if (this.editedDiscountItem.IsRepeat) {
        let month =
          this.editedDiscountItem.RepeatWarrantyPeriod * 1 +
          this.editedDiscountItem.GiveWarrantyPeriod * 1
        for (let index = 1; index <= month; index++) {
          array.push(index)
        }
        return array
      } else {
        let month =
          this.editedDiscount.WarrantyPeriod * 1 + this.editedDiscountItem.GiveWarrantyPeriod * 1
        for (let index = 1; index <= month; index++) {
          array.push(index)
        }
        return array
      }
    },
    groupDiscountItemDataTableHeaders () {
      return [
        { text: '已達折扣條件', value: 'IsAchieve' },
        { text: '啟用期數', value: 'UseWarrantyPeriod' },
        { text: '啟用期數換算天數', value: 'UseOnDay' },
        { text: '啟用月份', value: 'UseMonth' },
        { text: '折扣金額', value: 'DiscountPay' },
        { text: this.$t('common_look'), value: 'Edit', sortable: false }
      ]
    },
    computedDiscountRecordDataTableHeaders () {
      return [
        {
          text: this.$t('month_sale_item_start_date'),
          align: 'start',
          value: 'StartTime'
        },
        { text: this.$t('month_sale_item_end_date'), align: 'start', value: 'EndTime' },
        { text: this.$t('month_sale_item_pay_day'), align: 'end', value: 'UseDay' }
      ]
    },
    groupTitle () {
      return [
        { text: '', value: 'Sort' },
        { text: '', align: 'end', value: 'data-table-expand' }
      ]
    },
    discountRecordDataTableHeaders () {
      return [
        {
          text: '折扣日期',
          align: 'start',
          value: 'DiscountTime'
        },
        { text: '折扣金額', align: 'start', value: 'DiscountPay' },
        { text: this.$t('installation_notice_sale_number'), align: 'start', value: 'SaleNumber' }
      ]
    }
  },
  async mounted () {
    await this.getDiscountList()
    await this.countTotalRows()
    await this.getAllDiscountType()
    await this.getAllDiscountItemType()
  },
  methods: {
    async setFilterCustomer (val) {
      this.filterDiscount.CustomerId = val.Id
      this.filterDiscount = JSON.parse(JSON.stringify(this.filterDiscount))
      await this.getDiscountList()
    },
    setGiveWarrantyPeriod () {
      if (this.editedDiscountItem.DiscountType === 1) {
        if (this.editedDiscountItem.UseDiscountType === 1) {
          if (!this.editedDiscountItem.IsRepeat) {
            this.editedDiscountItem.GiveWarrantyPeriod = this.editedDiscountItem.UseWarrantyPeriods.length
          }
        } else {
          this.editedDiscountItem.GiveWarrantyPeriod = this.editedDiscountItem.Months.length
        }
        this.setGiveDay()
      }
    },
    setGiveDay () {
      this.editedDiscountItem.GiveDay = 0

      if (this.editedDiscountItem.UseDiscountType === 1) {
        if (
          this.editedDiscountItem.StartTime * 1 !== 0 &&
          this.editedDiscountItem.GiveWarrantyPeriod * 1 !== 0
        ) {
          this.editedDiscountItem.UseWarrantyPeriods.forEach((element) => {
            let startDate = new Date(this.editedDiscountItem.StartTime)
            let tempTime = startDate.setMonth(startDate.getMonth() + element * 1)
            let tempDate = new Date(tempTime)
            let day = new Date(tempDate.getFullYear(), tempDate.getMonth() + 1, 0).getDate()
            this.editedDiscountItem.GiveDay += day
          })
        }
      } else {
        if (
          this.editedDiscountItem.StartTime * 1 !== 0 &&
          this.editedDiscountItem.GiveWarrantyPeriod * 1 !== 0
        ) {
          this.editedDiscountItem.Months.forEach((element) => {
            let startDate = new Date(this.editedDiscountItem.StartTime)
            let day
            if (startDate.getMonth() + 1 <= element * 1) {
              day = new Date(startDate.getFullYear(), element * 1, 0).getDate()
            } else {
              day = new Date(startDate.getFullYear() + 1, element * 1, 0).getDate()
            }
            this.editedDiscountItem.GiveDay += day
          })
        }
      }
    },
    setAllDiscount () {
      this.editedDiscountItem.GiveMoney = 0
      this.editedDiscountItem.GivePercent = 0
      this.editedDiscountItem.GiveWarrantyPeriod = 0
      this.editedDiscountItem.GiveDay = 0
    },
    setUseDiscountType () {
      this.editedDiscountItem.Months = []
      this.editedDiscountItem.UseWarrantyPeriods = []
    },
    async getMonthList () {
      let response = await HttpMonth.GetMonthList({
        customerId: this.editedDiscount.CustomerId,
        licensePlate: this.editedDiscount.LicensePlate
      })
      this.monthItemList = response.status === 200 ? response.data.Data : []
    },
    setKeyDownAutocomplete () {
      ///  儲存keydown之前的Roles
      this.tempUseWarrantyPeriods = this.editedDiscountItem.UseWarrantyPeriods
    },
    setKeyUpAutocomplete (event) {
      this.$refs.useWarrantyPeriodsAutocomplete.isMenuActive = false
      this.$refs.useWarrantyPeriodsAutocomplete.isFocused = false
      ///  塞回keydown之前的Roles  給KeyUp的Model editedUser.Roles
      this.editedDiscountItem.UseWarrantyPeriods = this.tempUseWarrantyPeriods
      this.focusNextInput(event)
    },
    setUseDiscountTypeAutocomplete (event) {
      this.$refs.useDiscountTypeAutocomplete.isMenuActive = false
      this.$refs.useDiscountTypeAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    setDiscountTypeAutocomplete (event) {
      this.$refs.discountTypeAutocomplete.isMenuActive = false
      this.$refs.discountTypeAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    focusNextInput (event) {
      let form = document.getElementsByTagName('input')
      let targets = []
      for (let i = 0; i < form.length; i++) {
        if (form[i].type !== 'hidden' && !form[i].disabled && form[i].type !== 'checkbox') {
          targets.push(form[i])
        }
      }
      let index = Array.prototype.indexOf.call(targets, event.target)
      if (index !== -1) {
        let next = index + 1
        if (next < targets.length) {
          targets[next].focus()
          targets[next].select()
        }
      }
    },
    turnUseDiscountType (val) {
      return UseDiscountType.UseDiscountTypeName(val)
    },
    turnDiscountType (val) {
      return DiscountType.DiscountTypeName(val)
    },
    convertToDateTimeFormat (timestamp) {
      if (timestamp === 0) {
        return '-'
      } else {
        return this.$moment(new Date(timestamp)).format('YYYY-MM-DD')
      }
    },
    setStartTime (val) {
      this.editedDiscountItem.StartTime = val * 1
      this.setGiveDay()
    },
    async getAllDiscountType () {
      let response = await HttpDiscount.GetDiscountType()
      this.allDiscountType = response.status === 200 ? response.data.Data : []
      this.allDiscountType = this.allDiscountType.filter((x) => x.Type !== 4)
    },
    async getAllDiscountItemType () {
      let response = await HttpDiscount.GetDiscountItemType()
      this.allDiscountItemType = response.status === 200 ? response.data.Data : []
    },
    async countTotalRows () {
      if (this.isUpdateEventTotal) {
        let param = {
          CustomerId: this.filterDiscount.CustomerId,
          LicensePlate: this.filterDiscount.LicensePlate
        }
        let response = await HttpDiscount.GetDiscountCount(param)
        this.totalRows = response.status === 200 ? response.data.Data : 0
      }
    },
    async updateOptions (val) {
      this.currentOptions = val
      this.isUpdateEventTotal = false
      await this.getDiscountList(val)
    },
    async getDiscountList (val) {
      if (this.isUpdateEventTotal) {
        this.currentOptions.page = 1
        this.countTotalRows()
      }
      this.isUpdateEventTotal = true
      this.isLoadingDiscount = true
      let param = {
        CustomerId: this.filterDiscount.CustomerId,
        LicensePlate: this.filterDiscount.LicensePlate,
        ItemsPerPage:
          typeof val === 'object' && val ? val.itemsPerPage : this.currentOptions.itemsPerPage,
        Page: typeof val === 'object' && val ? val.page : this.currentOptions.page,
        SortBy: typeof val === 'object' && val ? val.sortBy[0] : this.currentOptions.sortBy,
        SortDesc: typeof val === 'object' && val ? val.sortDesc[0] : this.currentOptions.sortBy
      }
      let response = await HttpDiscount.GetDiscount(param)
      this.isLoadingDiscount = false
      this.discountList = response.status === 200 ? response.data.Data : []
    },
    async setCustomer (val) {
      this.editedDiscount.CustomerId = val.Id
      this.editedDiscount.CustomerNumber = val.Number
      this.editedDiscount.CustomerName = val.ShortName
      this.editedDiscount.CustomerFullName = val.FullName
      this.editedDiscount = JSON.parse(JSON.stringify(this.editedDiscount))
    },
    async isShowEditDiscountDialogBtn (item) {
      this.editedDiscountIndex = this.discountList.indexOf(item)
      this.editedDiscount = JSON.parse(JSON.stringify(item))
      await this.getMonthList()
      this.isShowEditDiscountDialog = true
    },
    closeEditDiscountDialog () {
      this.isShowEditDiscountDialog = false
      this.$nextTick(() => {
        this.editedDiscountIndex = -1
        this.editedDiscount = JSON.parse(JSON.stringify(this.defaultDiscount))
      })
    },
    async saveDiscount () {
      const isValid = await this.$refs.dialogDiscount.validate()
      if (isValid) {
        this.isLoadingSaveBtn = true
        this.isAllTextFieldDisable = true
        if (this.editedDiscountIndex === -1) {
          await HttpDiscount.AddDiscount(this.editedDiscount)
        } else {
          await HttpDiscount.UpdateDiscount(this.editedDiscount)
        }
        this.isLoadingSaveBtn = false
        this.isAllTextFieldDisable = false
        await this.getDiscountList()
        this.closeEditDiscountDialog()
      }
    },
    isShowDeleteDialogBtn (item) {
      this.editedDiscountIndex = this.discountList.indexOf(item)
      this.isShowDeleteDiscountDialog = true
    },
    closeDeleteDiscount () {
      this.editedDiscountIndex = -1
      this.isShowDeleteDiscountDialog = false
    },
    async confirmDeleteDiscount () {
      this.isLoadingSaveBtn = true
      this.isAllTextFieldDisable = true
      await HttpDiscount.UpdateDiscountIsDelete(this.discountList[this.editedDiscountIndex].Id)
      this.isLoadingSaveBtn = false
      this.isAllTextFieldDisable = false
      await this.getDiscountList()
      this.closeDeleteDiscount()
    },
    isShowEditDiscountItemDialogBtn (item) {
      this.editedDiscountItemIndex = this.editedDiscount.NewDiscountItems.indexOf(item)
      this.editedDiscountItem = JSON.parse(JSON.stringify(item))
      this.isShowEditDiscountItemDialog = true
    },
    closeEditDiscountItem () {
      this.isShowEditDiscountItemDialog = false
      this.$nextTick(() => {
        this.editedDiscountItemIndex = -1
        this.editedDiscountItem = JSON.parse(JSON.stringify(this.defaultDiscountItem))
      })
    },
    generateObjectId () {
      const timestamp = Math.floor(Date.now() / 1000)
        .toString(16)
        .padStart(8, '0')
      const randomBytes = Array.from({ length: 16 }, () =>
        Math.floor(Math.random() * 16).toString(16)
      ).join('')
      return timestamp + randomBytes
    },
    async addDiscountItem () {
      const isValid = await this.$refs.discountItem.validate()
      if (isValid) {
        if (this.editedDiscountItemIndex === -1) {
          if (this.editedDiscountItem.DiscountType !== 2) {
            if (
              this.editedDiscountItem.MonthItemId === '' ||
              this.editedDiscountItem.MonthItemId === null
            ) {
              // 只處理進行中的合約 (MonthStatus === 1)，排除暫停(2)和終止(4)
              this.monthItemList
                .filter((x) => x.MonthStatus === 1)
                .forEach((element) => {
                  this.editedDiscount.NewDiscountItems.push({
                    DiscountId: this.generateObjectId(),
                    DiscountType: this.editedDiscountItem.DiscountType,
                    MonthWarrantyPeriod: element.RentWarrantyPeriod,
                    MonthId: element.Id,
                    MonthNumber: element.Number,
                    MonthItemId: element.ItemId,
                    MonthItemName: element.ItemName,
                    MonthItemNumber: element.ItemNumber,
                    StartTime: this.editedDiscountItem.StartTime,
                    IsRepeat: this.editedDiscountItem.IsRepeat,
                    RepeatWarrantyPeriod: this.editedDiscountItem.RepeatWarrantyPeriod,
                    GiveWarrantyPeriod: this.editedDiscountItem.GiveWarrantyPeriod,
                    GiveMoney: this.editedDiscountItem.GiveMoney,
                    GiveDay: this.editedDiscountItem.GiveDay,
                    GivePercent: this.editedDiscountItem.GivePercent,
                    UseDiscountType: this.editedDiscountItem.UseDiscountType,
                    UseWarrantyPeriods: this.editedDiscountItem.UseWarrantyPeriods,
                    Remark: this.editedDiscountItem.Remark,
                    Month: this.editedDiscountItem.Month,
                    Months: this.editedDiscountItem.Months,
                    GroupDiscountList: []
                  })
                })
            } else {
              this.editedDiscountItem.DiscountId = this.generateObjectId()
              this.editedDiscount.NewDiscountItems.push(this.editedDiscountItem)
            }
          } else {
            this.editedDiscountItem.DiscountId = this.generateObjectId()
            this.editedDiscount.NewDiscountItems.push(this.editedDiscountItem)
          }
        } else {
          this.editedDiscount.NewDiscountItems.splice(
            this.editedDiscountItemIndex,
            1,
            this.editedDiscountItem
          )
        }
        this.closeEditDiscountItem()
      }
    },
    isShowDeleteDiscountItemDialogBtn (item) {
      this.editedDiscountItemIndex = this.editedDiscount.NewDiscountItems.indexOf(item)
      this.isShowDeleteDiscountItemDialog = true
    },
    closeDeleteDiscountItem () {
      this.isShowDeleteDiscountItemDialog = false
      this.$nextTick(() => {
        this.editedDiscountItemIndex = -1
      })
    },
    confirmDeleteDiscountItem () {
      this.editedDiscount.NewDiscountItems.splice(this.editedDiscountItemIndex, 1)
      this.closeDeleteDiscountItem()
    },
    combineText (item) {
      return (
        this.$t('discount_item_title') +
        item.Sort +
        this.$t('discount_item_title_second') +
        '　　　　' +
        this.$t('discount_item_title_time') +
        '　:　' +
        this.convertToDateTimeFormat(item.DiscountStartTime)
      )
    },
    isShowEditGroupDiscountItemDialogBtn (index, item) {
      this.editedGroupDiscountItemIndex = index
      this.editedGroupDiscountItem = JSON.parse(JSON.stringify(item))
      this.isShowEditGroupDiscountItemDialog = true
    },
    closeEditGroupDiscountItem () {
      this.isShowEditGroupDiscountItemDialog = false
      this.$nextTick(() => {
        this.editedGroupDiscountItemIndex = -1
        this.editedGroupDiscountItem = JSON.parse(JSON.stringify(this.defaultGroupDiscountItem))
      })
    },
    setEditedDiscountItem (val) {
      this.editedDiscountItem.MonthId = val.Id
      this.editedDiscountItem.MonthNumber = val.Number
      this.editedDiscountItem.MonthItemId = val.ItemId
      this.editedDiscountItem.MonthItemNumber = val.ItemNumber
      this.editedDiscountItem.MonthItemName = val.ItemName
      this.editedDiscountItem.MonthWarrantyPeriod = val.RentWarrantyPeriod
      this.editedDiscountItem = JSON.parse(JSON.stringify(this.editedDiscountItem))
    },
    onWaitForDiscountIdsChange (selectedIds) {
      // 當選擇第一個項目時，自動設置品項
      if (selectedIds && selectedIds.length > 0) {
        // WaitForDiscountIds 有值時，StartTime 設為 0
        this.editedDiscountItem.StartTime = 0
        let selectedDiscountItem = (this.editedDiscount.NewDiscountItems || []).find(
          (x) => x.DiscountId === selectedIds[0]
        )
        if (selectedDiscountItem) {
          // 從 monthItemList 找到對應的品項
          let monthItem = this.monthItemList.find(
            (x) => x.ItemNumber === selectedDiscountItem.MonthItemNumber
          )
          if (monthItem) {
            this.setEditedDiscountItem(monthItem)
          }
        }
      } else {
        this.editedDiscountItem = JSON.parse(JSON.stringify(this.defaultDiscountItem))
      }
    }
  }
}
</script>
